<app-popover class="view-invoice-form" (closeCallback)="closePopOver()" size="xlarge">
  <div popover-header>
    BOOKING ID {{booking.bookingId}}
    <app-button type="primaryOutline" text="Download Invoice" class="download-invoice" (clickCallback)="downloadInvoice()"></app-button>
  </div>
  <div popover-content>
    <div *ngIf="invoiceImage ? true : false">
      <img [src]="getSafeUrl()" />
    </div>
  </div>
  <div popover-actions class="actions-wrapper">
    <button class="button-red mr-10" (click)="rejectInvoice()">
      <img src="assets/reject.svg"/>
      <span class="button-text">Reject</span>
    </button>
    <button class="button-green" (click)="approveInvoice()">
      <img src="assets/approve.svg"/>
      <span class="button-text">Accept</span>
    </button>
  </div>
</app-popover>
